<template>
  <div>
    <ContentHeader :path-info="pathInfo" :path-set-type="'replace'" />
    <div class="content-container" v-loading="infoLoading">
      <div class="item-detail">
        <div class="item-image">
          <div class="item-image-large">
            <img :src="getImageUrl(showImage)" />
          </div>
          <div class="item-image-preview">
            <div
              class="item-image-small cursor"
              :class="{ active: index === curIndex }"
              v-for="(item, index) in itemInfo.imageList"
              :key="index"
              @mouseover="handleShow(item.imageFileUri, index)"
            >
              <img :src="getImageUrl(item.imageFileUri)" />
            </div>
          </div>
        </div>
        <div class="item-info" :class="{'item-info-print' :itemInfo.isPrints}">
          <div class="item-title">{{ itemInfo.itemName }}</div>

          <div class="item-info-box">
            <el-row class="item-info-detail">
              <el-col :span="24">
                <div v-if="this.$route.query.from === 'apply'">编码：{{ itemCode }}</div>
                <div v-else>编码：{{ itemInfo.itemCode }}</div>
                <div>品牌：
                  <span v-for="(item, index) in itemBrandList" :key="index">
                    {{ item.abiBrandName }}
                    <span v-if="index < itemBrandList.length - 1">,</span>
                  </span>
                </div>
                <div v-if="this.$route.query.from === 'apply'">配额有效时间：{{ effectiveDate | parseTime('{y}-{m}-{d}') }} - {{ expireDate | parseTime('{y}-{m}-{d}') }}</div>
                <div v-if="this.$route.query.from === 'apply'">分配额度：{{ quotaInfo.totalQuota }}</div>
                <div v-if="this.$route.query.from === 'apply'">剩余额度：{{ quotaInfo.availableQuota }}</div>
                <div>制作周期：{{ itemInfo.productTime }}</div>
                <div>物流周期：{{ itemInfo.logisticsTime }}</div>
                <div>供应商：{{ itemInfo.produceSupplierName }}</div>
              </el-col>
            </el-row>
          </div>

          <div class="item-quantity" v-if="this.$route.query.from === 'apply'">
            <span class="item-quantity-info">数量</span>
            <el-input-number
              disabled
              value=1
              label="描述文字"
            ></el-input-number>
          </div>
          <div class="item-button" v-if="this.$route.query.from === 'apply'">
            <el-button class="item-button-order" @click="handelOrderNow">
              立即领用
              <i class="iconfont iconzu121" />
            </el-button>
          </div>
        </div>
      </div>
      <div class="item-more">
        <div class="item-tab">
          <el-tabs v-model="activeTab" type="card">
            <el-tab-pane class="item-tab-info" label="物料详情" name="item-detail">
              <div v-html="itemInfo.itemDesc"></div>
            </el-tab-pane>
            <el-tab-pane class="item-tab-info" label="具体参数" name="item-spec">
              <div v-html="itemInfo.specInfo"></div>
            </el-tab-pane>
          </el-tabs>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ContentHeader from '../../components/content-header'
import freezerApi from '@/api/freezer'
import { commonUtils } from '@/utils/common'
export default {
  components: {
    ContentHeader
  },
  data () {
    return {
      itemInfo: {},
      quotaInfo: {},
      activeName: 'detailInfo',
      url: '',
      effectiveDate: '',
      expireDate: '',
      itemCode: '',
      pathInfo: [],
      infoLoading: false,
      curIndex: 0,
      showImage: '',
      activeTab: 'item-detail',
      itemBrandList: []
    }
  },
  created () {
    this.queryFreezerList()
    this.getQuotaInfo()
    console.log(this.$route.query.effectiveDate)
    this.effectiveDate = Number(this.$route.query.effectiveDate)
    this.expireDate = Number(this.$route.query.expireDate)
    this.itemCode = this.$route.query.itemCode
  },
  methods: {
    // 获取资产冰柜信息
    queryFreezerList () {
      this.infoLoading = true
      freezerApi.getFreezerInfo(this.$route.query.freezerId).then(res => {
        this.infoLoading = false
        if (res.data.resultCode === '0') {
          this.itemInfo = res.data.resultData.itemInfo
          this.itemBrandList = res.data.resultData.itemInfo.itemBrandList
          if (this.itemInfo.imageList && this.itemInfo.imageList.length) {
            this.showImage = this.itemInfo.imageList[0].imageFileUri
          }
        }
      })
    },

    handleShow (img, index) {
      this.showImage = img
      this.curIndex = index
    },

    // 点击立即领用
    handelOrderNow () {
      this.$router.push({
        path: '/freezer/fill-order',
        query: {
          detailId: this.$route.query.detailId,
          itemId: this.$route.query.freezerId
        }
      })
    },

    // 查询配额
    getQuotaInfo () {
      if (this.$route.query.from) {
        freezerApi.getQuotaInfo(this.$route.query.detailId).then(res => {
          this.quotaInfo = res.data.resultData.quotaDTO
        })
      }
    },
    getImageUrl (url) {
      return commonUtils.getImageUrl(url)
    }
  }
}
</script>

<style lang="scss" scoped>
.item-detail {
  display: flex;
  margin-bottom: 17px;
  width: 100%;
  background: $base-white;
  .item-image {
    position: relative;
    width: 460px;
    height: 515px;
    padding: 15px 23px 0 23px;
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);
    border-radius: 5px;
    .item-image-large {
      height: 414px;
      width: 414px;
      display: flex;
      align-items: center;
      justify-content: center;
      img {
        max-width: 100%;
        max-height: 100%;
      }
    }
    .item-image-preview {
      padding-top: 10px;
      margin-bottom: 10px;
      display: flex;
      justify-content: center;
      .item-image-small {
        height: 50px;
        width: 50px;
        border: 1px solid #ddd;
        margin-right: 10px;
        display: flex;
        align-items: center;
        justify-content: center;
        img {
          max-width: 100%;
          max-height: 100%;
        }
      }
      .active {
        border-color: $base-red;
      }
    }
  }
  .item-info {
    flex: 0.54 1 auto;
    height: 100%;
    width: calc(100% - 460px);
    .item-title {
      height: 40px;
      padding: 15px 0 15px 63px;
      line-height: 40px;
      font-size: 30px;
      font-weight: bold;
      letter-spacing: 0px;
    }
    .item-info-box {
      width: 100%;
      padding-left: 63px;
      padding-bottom: 70px;
      box-sizing: border-box;
      .item-info-detail {
        font-size: $font-12;
        line-height: 24px;
        div {
          margin-top: 2px;
        }
      }

      .item-info-radio {
        display: flex;
        margin-top: 10px;
        flex-wrap: wrap;
        font-size: 12px;
        .el-col-2 {
          padding-top: 8px;
        }
        .el-radio-group {
          margin-right: 10px;
          margin-bottom: 6px;
        }
      }
    }
    .item-quantity {
      padding: 20px 0 20px 20px;
      margin: 0 38px;
      border-bottom: 1px solid $base-grey;
      border-top: 1px solid $base-grey;
      .item-quantity-info {
        padding-right: 42px;
        font-size: $font-12;
        color: #333333;
      }
    }
    .item-button {
      margin-top: 45px;
      padding-bottom: 26px;
      text-align: center;
      .item-button-order {
        width: 160px;
        background-color: $base-red;
        color: $base-white;
      }
    }
  }
}
.item-more {
  background-color: $base-white;
  .item-tab-info {
    padding: 0 100px $content-middle 100px;
  }
  .item-tab {
    .item-more-box {
      border-top: 1px solid $base-grey;
      text-align: center;
      .item-more-image {
        width: 720px;
        height: 515px;
      }
    }
  }
}
</style>
